<template>
  <asc-dialog
    class="asc-flow-selection-dialog--container"
    :show-title="false"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="435"
  >
    <template v-if="showDialog">
      <div class="asc-flow-selection--container">
        <div v-if="title || subtitle" class="asc-flow-selection--header">
          <h1 v-if="title" class="title">{{ title }}</h1>
          <p v-if="subtitle" :class="[customSubtitleClass, 'subtitle']">
            {{ subtitle }}
          </p>
        </div>
        <div class="asc-flow-selection--options">
          <div
            v-for="(type, key, index) in definition"
            :key="index"
            class="asc-flow-selection--option"
          >
            <asc-accent-button
              :block="true"
              :on-click="handleClick"
              :button-text="type.name"
              :custom-class="getSelectedClass(type.name)"
              secondary
              :icon="getIcon"
              :disabled="type.disabled ? type.disabled : false"
            ></asc-accent-button>
            <asc-label
              v-if="type.description"
              size="md"
              :value="type.description"
              class="description"
            ></asc-label>
          </div>
        </div>
        <div v-if="checkButtons">
          <v-row justify="space-between" no-gutters class="flex-shrink-0">
            <div class="ml-2 mt-2">
              <asc-link-button
                :prepend-icon="linkIcon"
                :text="linkText"
                :uppercase="false"
                :hover="false"
                @click="onBackClick"
              ></asc-link-button>
            </div>
          </v-row>
        </div>
      </div>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialogMixin from '../mixins/AscDialogMixin.vue'
import AscDialog from '../atoms/AscDialog.vue'
import AscAccentButton from '../atoms/AscAccentButton.vue'
import AscLabel from '../atoms/AscLabel.vue'
import AscLinkButton from '../atoms/AscLinkButton.vue'

export default {
  name: 'AscFlowSelectionDialog',

  components: {
    AscDialog,
    AscAccentButton,
    AscLabel,
    AscLinkButton,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    customSubtitleClass: {
      type: String,
      default: '',
    },
    definition: {
      type: Array,
      required: true,
    },
    onSelection: {
      type: Function,
      default: () => {},
    },
    linkIcon: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '< Go Back',
    },
    buttonText: {
      type: String,
      default: 'Next',
    },
    onPrimary: {
      type: Function,
      default: () => {},
    },
    onBackClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: undefined,
    },
    checkButtons: {
      type: Boolean,
      default: false,
    },
    optionIcon: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      selectedType: null,
      selectedValue: '',
    }
  },

  computed: {
    getIcon() {
      return this.optionIcon ? 'mdi-chevron-right' : ''
    },
  },

  methods: {
    getSelectedClass(name) {
      if (this.definition.length <= 1 || name === this.selectedValue)
        return this.customClass
      else return ''
    },
    handleClick(e, value) {
      const selectedObj = this.definition.find(type => type.name === value)
      this.selectedValue = value
      if (selectedObj) {
        if (this.onSelection) {
          this.onSelection(selectedObj)
        }
      }
    },
  },
}
</script>

<style lang="scss">
.selection {
  background-color: $accent-100 !important;
}

.v-icon {
  top: -1px !important;
}

.asc-flow-selection-dialog--container {
  .asc-dialog {
    .v-card {
      .asc-dialog-slot {
        min-height: 320px !important;
      }
      &__title {
        padding-bottom: 0 !important;
        height: 0;

        .asc-close-button {
          right: -2px;
          top: -3px;

          .v-icon {
            color: $primary-black !important;
            font-weight: bold;
          }
        }
      }

      &__text {
        padding-bottom: 16px !important;

        .asc-flow-selection {
          &--header {
            margin-bottom: 15px;
            padding: 8px 25px 0 8px;

            .title {
              color: $primary-black;
              font-size: $font-size-md !important;
              font-weight: 500;
              letter-spacing: 1px !important;
              line-height: 18px;
              margin: 0 0 14px 0;
              text-transform: uppercase;
            }

            .subtitle {
              color: $gray-1000;
              font-size: $font-size-md;
              letter-spacing: 0;
              line-height: 18px;
              margin: 0;
              padding-top: 20px;
            }
          }

          &--options {
            .asc-flow-selection--option {
              margin-bottom: 1px;
              padding: 10px 16px 18px 16px;

              .v-btn__content {
                display: inline;
              }

              .v-icon {
                float: right;
              }

              .asc-label.description {
                margin: 14px 0 0 0;
                line-height: 18px;
                display: block;
              }

              &:last-child {
                margin-bottom: 10;
              }
            }
          }
        }
      }
    }
  }
}
</style>
